import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SolicitudService } from "../../../services/ms-backoffice/solicitud.service";
import { SolicitudBoSession } from "../../../models/solicitud-bo";
import { ClientService } from "../../../services/client.service";
import { Client, ClientData, ClientReniec } from "../../../models/client";
import { AppConstants, TipoSolicitudBO } from "../../../shared/constants/app.constants";
import { Cliente, Producto } from "../../../models/simular";
import { finalize, switchMap } from "rxjs/operators";
import { throwError } from "rxjs";
import { AlertService, MessageSeverity } from "../../../shared/services/alert.service";
import { HttpErrorResponse } from "@angular/common/http";
import * as moment from 'moment';

@Component({
  selector: "app-products-line-increment",
  templateUrl: "./products-line-increment.component.html",
  styleUrls: ["./products-line-increment.component.css"],
})
export class ProductsLineIncrementComponent implements OnInit {
  solicitudSession: SolicitudBoSession = new SolicitudBoSession();
  loading: boolean = false;
  clienteSession: Cliente = JSON.parse(sessionStorage.getItem(AppConstants.ObjectCliente.CLIENTE));
  productoSession: Producto = JSON.parse(sessionStorage.getItem(AppConstants.ObjectCliente.PRODUCTO));
  salesChannel: string = sessionStorage.getItem(AppConstants.Session.SALESCHANNEL);
  title: string = "INCREMENTO DE LÍNEA";
  imagen: string = "incremento-linea.png";
  clientData: ClientData = new ClientData();
  docType: string = "";
  docNumber: string = "";
  client: Client;
  isDataReady: boolean = false;
  constructor(
    private solicitudService: SolicitudService,
    private router: Router,
    private clientService: ClientService,
    private alertaService: AlertService,
  ) {}

  async ngOnInit() {
    this.callLoadClient(this.clienteSession.NumeroSolicitud);
  }

  callLoadClient(solicitudId: string) {
    this.loading = true;
    this.clientService.getClient(solicitudId)
      .pipe(
        switchMap((client) => {
          if (client == null) {
            return throwError("Cliente No encontrado");
          }
          this.client = client;
          return this.clientService.getClientReniec(client.tipoDocumento, client.numeroDocumento, client.solId, client.offerProduct);
        }),
        finalize(() => this.loading = false)
      )
      .subscribe(
        (response) => {
          this.setData(this.client, response);
          this.loading = false;
        },
        (error) => {
          this.alertaService.showMessage('Error', error.error.messages, MessageSeverity.error);
          this.loading = false;
        }
      );
  }

  setData(clientSolicitud: Client,clientReniec: ClientReniec){
    const modelClient = clientSolicitud
    clientSolicitud.nombres = clientReniec.nombres
    clientSolicitud.fecEmision = moment(clientReniec.fechaEmisionDocumento).format('DD/MM/YYYY')
    // Datos de la Solicitud del Cliente
    this.solicitudSession.tipoSolicitud = TipoSolicitudBO.IncrementoLinea;
    this.solicitudSession.solicitudBOId = clientSolicitud.solId;
    this.solicitudSession.tipoDocumento = clientSolicitud.tipoDocumento;
    this.solicitudSession.correoCliente = clientSolicitud.email;
    this.solicitudSession.tipoDocumentoName = clientSolicitud.tipoDocumentoString;
    this.solicitudSession.numeroDocumento = clientSolicitud.numeroDocumento;
    this.solicitudSession.nombreCliente = clientSolicitud.nombres + " " + clientSolicitud.apellidoPaterno + " " + clientSolicitud.apellidoMaterno;
    this.solicitudSession.montoIncremento = clientSolicitud.offeLinFina;
    this.solicitudService.setSolicitudBoSession(this.solicitudSession);
    // Datos de Reniec
    this.clientData.documentNumber = this.solicitudSession.numeroDocumento;
    this.clientData.fullName = clientReniec.nombres;
    this.clientData.lastName = clientReniec.apellidoPaterno;
    this.clientData.secondLastName = clientReniec.apellidoMaterno;
    this.clientData.dateOfBirth = clientReniec.fechaNacimiento;
    this.clientData.email = clientReniec.correo;
    this.clientData.startDate = clientReniec.fechaEmisionDocumento;
    //this.clientData.reniecImage = clientReniec.reniecImage == null ? "/assets/images/Frame.png" : "data:image/png;base64," + clientReniec.reniecImage;
    this.clientData.reniecImage = clientReniec.reniecImage == null ? "" : clientReniec.reniecImage;
    this.clientData.situation = clientReniec.situacionCliente;
     
        this.loading = true;
        this.clientService.updateClient(modelClient).subscribe((response) => {
          this.loading = false;
          this.alertaService.showMessage(AppConstants.TitleModal.UPDATE_CLIENT, AppConstants.MessageModal.UPDATE_CLIENT_MESSAGE_OK, MessageSeverity.success);
        },
        (error: HttpErrorResponse) => {
            this.loading = false;
            this.alertaService.showMessage(AppConstants.TitleModal.UPDATE_CLIENT, error.error.messages, MessageSeverity.error);
        });
    
    this.isDataReady = true;
  }

  regresar() {
    this.router.navigate(["/productsList"]);
  }

  siguiente() {
    this.router.navigate(["/solicitud/verificacion"]);
  }

}
